import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TextField from '@/modules/common/components/TextField';
import TextHelpField from '@/modules/common/components/TextHelpField';
import TableContainer from '@/modules/common/components/TableContainer';
import Button from '@/modules/common/components/Button';

const map1 = [
    ['Название оффера', '{offer_name}'],
    ['URL', '{url}'],
    ['Сообщение', '{message}'],
];

const map2 = [
    ['Название оффера', '{offer_name}'],
];


const Form = (props) => {
    const handleChange = (prop) => (event) => {
        props.setValues({...props.values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        props.setErrors({...props.errors, [prop]: ''});
    };

    // noinspection JSValidateTypes
    return (
        <form id="form-settings-alarm" onSubmit={props.onSubmit}>
            <TextField label="Интервал проверки 1 (сек.)" type="number" inputProps={{min: 5}}
                       value={props.values.interval1}
                       onChange={handleChange('interval1')}
                       error={props.errors.interval1.length > 0}
                       helperText={props.errors.interval1}
                       onFocus={handleFocus('interval1')}
            />
            <TextField label="Интервал проверки 2 (сек.)" type="number" inputProps={{min: 5}}
                       value={props.values.interval2}
                       onChange={handleChange('interval2')}
                       error={props.errors.interval2.length > 0}
                       helperText={props.errors.interval2}
                       onFocus={handleFocus('interval2')}
            />
            <TextField label="Тайм-аут HTTP запроса (сек.)" type="number" inputProps={{min: 1}}
                       value={props.values.httpTimeout}
                       onChange={handleChange('httpTimeout')}
                       error={props.errors.httpTimeout.length > 0}
                       helperText={props.errors.httpTimeout}
                       onFocus={handleFocus('httpTimeout')}
            />
            <TextHelpField label="Формат сообщения 1" popover={{id: 'popover-alarm-error-message-format1'}}
                           value={props.values.errorMessage1Format}
                           onChange={handleChange('errorMessage1Format')}
                           error={props.errors.errorMessage1Format.length > 0}
                           helperText={props.errors.errorMessage1Format}
                           onFocus={handleFocus('errorMessage1Format')}
            >
                <TableContainer><Table><TableBody>
                    {map1.map(([title,placeholder], id) => (
                        <TableRow key={id}>
                            <TableCell className="highlight">{title}</TableCell>
                            <TableCell>{placeholder}</TableCell>
                        </TableRow>
                    ))}
                </TableBody></Table></TableContainer>
            </TextHelpField>
            <TextHelpField label="Формат сообщения 2" popover={{id: 'popover-alarm-error-message-format2'}}
                           value={props.values.errorMessage2Format}
                           onChange={handleChange('errorMessage2Format')}
                           error={props.errors.errorMessage2Format.length > 0}
                           helperText={props.errors.errorMessage2Format}
                           onFocus={handleFocus('errorMessage2Format')}
            >
                <TableContainer><Table><TableBody>
                    {map2.map(([title,placeholder], id) => (
                        <TableRow key={id}>
                            <TableCell className="highlight">{title}</TableCell>
                            <TableCell>{placeholder}</TableCell>
                        </TableRow>
                    ))}
                </TableBody></Table></TableContainer>
            </TextHelpField>
            <div className="submit">
                <Button type="submit" disabled={props.disabled}>
                    Сохранить
                </Button>
            </div>
        </form>
    );
};

Form.propTypes = {
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    setErrors: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
};

export default Form;
